import * as Yup from 'yup';
import { phoneSchema } from 'modules/emergencies/components/ticketForm/config/ticketFormSchema.js';
export default Yup.object().shape({
  phone: phoneSchema(),
  first_name: Yup.string().required('Required'),
  email: Yup.string().email().required('Required'),
  language: Yup.string().required('Required'),
  carrier_user_groups: Yup.array().of(Yup.number()),
});
